<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M7.999999940395355,16C12.666699940395356,12.9524,14.999999940395355,8.7619,14.999999940395355,3.42857C13.444399940395355,3.42857,11.111099940395356,2.28571,7.999999940395355,0C4.888889940395355,2.28571,2.555559940395355,3.42857,0.9999999403953552,3.42857C0.9999999403953552,8.7619,3.3333299403953554,12.9524,7.999999940395355,16C7.999999940395355,16,7.999999940395355,16,7.999999940395355,16ZM7.999999940395355,2.12123C10.004689940395355,3.50885,11.714799940395356,4.42518,13.185699940395356,4.85645C12.843699940395355,8.55812,11.135199940395355,11.5394,7.999999940395355,13.8942C7.999999940395355,13.8942,7.999999940395355,2.12123,7.999999940395355,2.12123C7.999999940395355,2.12123,7.999999940395355,2.12123,7.999999940395355,2.12123Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Shield',
} as DefineComponent
</script>
